module.exports = __webpack_public_path__ + "static/media/co2.0393c3ce.jpg";